import HorizontalScrollContainer from './horizontal-scroll-container'

export default HorizontalScrollContainer
